import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useIntl } from "react-intl";
import { addDemoStore } from "store/actions";
import Loader from "components/shared/loader";
import { toastErrorMessage } from "helpers/toaster/toastErrorMessage";
import SaveChangesButton from "components/Form/SaveChangesButton";
import FormWrapper from "components/Form/FormWrapper";
import Form from "components/Form";
import Input from "components/Form/Input";
import { handleErrMsg } from "helpers/functions";
import { Col, Row } from "react-bootstrap";
import "styles/applications.css";

const AddApplication = () => {
  const { formatMessage, locale } = useIntl();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { loading, error } = useSelector((state) => state.demoStores);

  // error
  useEffect(() => {
    if (Object.keys(error)?.length > 0) {
      toastErrorMessage(formatMessage({ id: handleErrMsg(error) }), locale);
    }
  }, [error, formatMessage, locale, navigate]);

  const onSubmitDetails = (data) => {
    dispatch(addDemoStore({ data, navigate }));
  };

  if (loading) return <Loader />;
  return (
    <div className="applications">
      <FormWrapper title={"addEmployee"} lg={12}>
        <Col lg={12}>
          <Form onSubmit={onSubmitDetails}>
            <div className="form-group branches features">
              <Row>
                <Input
                  name="storeName"
                  lg="7"
                  autoCapitalize="off"
                  autoComplete="off"
                  autoCorrect="off"
                  spellCheck="false"
                />
                <Input
                  type="password"
                  name="password"
                  autoCapitalize="off"
                  autoComplete="off"
                  autoCorrect="off"
                  spellCheck="false"
                />
                <Input
                  type="password"
                  name="confirmPassword"
                  autoCapitalize="off"
                  autoComplete="off"
                  autoCorrect="off"
                  spellCheck="false"
                />

                <SaveChangesButton className="mt-2 justify-content-end" />
              </Row>
            </div>
          </Form>
        </Col>
      </FormWrapper>
    </div>
  );
};

export default AddApplication;
